import { IcoPath } from "assets/icons";
import styles from "./styles.module.scss";
import { PannelCardProps } from "./types";

export default function PannelCard({
	month,
	totalTravels,
	totalRevenue
}: PannelCardProps) {
	return (
		<div className={styles.pannel}>
			<span>{month}</span>
			<div className={styles.pannelData}>
				<div className={styles.dataItem}>
					<div className={styles.icon}>
						<IcoPath />
					</div>
					<span>{totalTravels}</span>
				</div>
				{/*
				<div className={styles.dataItem}>
					<div className={styles.icon}>
						<IcoMoney />
					</div>
					<span>{totalRevenue}</span>
				</div>
				*/}
			</div>
		</div>
	);
}
